import React from "react";

const NavInfoAccount = () => {
    return (
        <>
            <div className="semester-nav-info">
                <div className="side-nav-info-header">
                    Your Account
                </div>
                <div className="text-side-nav">
                    Update your account settings and information to the right.
                </div>
            </div>
        </>
    );
}

export default NavInfoAccount;